export default function initBlockquoteTemoignage() {
    const blockquoteTemoignage = document.querySelectorAll('.js-blockquote-temoignage');
    
    blockquoteTemoignage.forEach((container: Element) => {
        new BlockquoteTemoignage(container);
    });
}

class BlockquoteTemoignage {
    private $el: Element;
    private $buttonToggle: HTMLButtonElement | null;
    private $textMin: HTMLSpanElement | null;
    private $textMax: HTMLSpanElement | null;

    constructor($el: Element) {
        this.$el = $el;
        this.$buttonToggle = this.$el.querySelector('.js-btn-toggle-text-temoignage');
        this.$textMin = this.$el.querySelector('.js-text-temoignage-min');
        this.$textMax = this.$el.querySelector('.js-text-temoignage-max');

        this.$buttonToggle?.addEventListener('click', ()=> {
            this.toggleText();
        });
    }

    private toggleText(): void {
        if (!this.$textMin || !this.$textMax || !this.$buttonToggle) {
            return;
        }

        const isTextMaxVisible = this.$textMax.style.display !== 'none';

        if (isTextMaxVisible) {
            // Afficher textMin, cacher textMax
            this.$textMin.style.display = '';
            this.$textMax.style.display = 'none';
            this.$buttonToggle.textContent = 'Voir plus';
        } else {
            // Afficher textMax, cacher textMin
            this.$textMin.style.display = 'none';
            this.$textMax.style.display = '';
            this.$buttonToggle.textContent = 'Voir moins';
        }
    }
}


